import { useQuery } from '@tanstack/react-query';
import { supabase, handleSupabaseError, handleUnexpectedError } from '@/lib';
import { Membership } from '@/types';
import { MEMBERSHIP_QUERY_KEYS } from '@/constants';

export function useMemberMemberships(memberId: string) {
  return useQuery({
    queryKey: MEMBERSHIP_QUERY_KEYS.BY_MEMBER(memberId),
    queryFn: async () => {
      try {
        if (!memberId) {
          // Return empty array for missing member ID - don't throw error
          return [] as Membership[];
        }

        const { data, error } = await supabase
          .from('memberships')
          .select('*')
          .eq('member_id', memberId)
          .order('start_date', { ascending: false });

        if (error) handleSupabaseError(error, { operation: 'fetching member memberships', params: { memberId } });

        return data as Membership[];
      } catch (error) {
        handleUnexpectedError(error, { hookName: 'useMemberMemberships', operation: 'loading member memberships', params: { memberId } });
      }
    },
    // Tab-click on the member-profile screen unmounts/remounts the
    // section, and we want fresh data on every tab visit instead of a
    // 5-minute-stale cache snapshot.
    refetchOnMount: 'always',
  });
}